var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-projects"},_vm._l((_vm.allTags),function(elem,index){return _c('p',{key:index,on:{"click":_vm.changeStatus}},[_vm._v("#"+_vm._s(elem))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }